import React from 'react';

type Props = {
  all: number;
  completed: number;
};

const CounterComp = ({ all, completed }: Props) => {
  return (
    <div
      className='counter-container'
      style={{
        backgroundColor:
          completed === all
            ? '#E1FCED'
            : completed < all && completed !== 0
            ? '#FBFBC2'
            : '#F8F8F8',
      }}
    >
      {completed} of {all} completed
    </div>
  );
};

export default CounterComp;
